// UI-level presentation helpers for the branded-fare-upsell components.
// Offer-shape utilities live in @liveflight/utilities/flight-offer;
// fare-choice pipeline helpers live on the provider — no re-exports here.

export const show_amenity = (amenity) => !amenity.isChargeable;

export const get_fare_button_text = (
  item,
  selected_flight_offer_id,
  flight_offer_default
) => {
  if (item.id === selected_flight_offer_id) {
    if (item.id === flight_offer_default.id) {
      return 'Default';
    }
    return 'Rimuovi';
  }
  return 'Scegli';
};

export const is_amenity_present = (offers_amenities, offer_id, amenity_code) =>
  (offers_amenities[offer_id] || [])
    .map((amenity) => amenity.code)
    .includes(amenity_code);

export const toggle_selected_class = (item, selected_flight_offer_id) =>
  item.id === selected_flight_offer_id ? 'selected' : '';

const INFERABLE_AMENITIES = {
  'INF:BACKPACK': {
    sortOrder: 0,
    code: 'INF:BACKPACK',
    description: (quantity = 1) =>
      `${quantity > 1 ? `${quantity} ` : ''}Bagagli${quantity === 1 ? 'o' : ''} personal${quantity === 1 ? 'e' : 'i'} piccol${quantity === 1 ? 'o' : 'i'}`,
    icon: 'backpack',
    tooltip: 'Dimensioni da controllare sul sito della compagnia',
  },
  'INF:CABIN': {
    sortOrder: 1,
    code: 'INF:CABIN',
    description: (quantity = 1) =>
      `${quantity > 1 ? `${quantity} ` : ''}Bagagli${quantity === 1 ? 'o' : ''} a mano`,
    icon: 'trolley',
    tooltip: 'Dimensioni da controllare sul sito della compagnia',
  },
  'INF:CHECKED': {
    sortOrder: 2,
    code: 'INF:CHECKED',
    description: (quantity = 1) =>
      `${quantity > 1 ? `${quantity} ` : ''}Bagagli${quantity === 1 ? 'o' : ''} in stiva`,
    icon: 'luggage',
    tooltip: 'Dimensioni da controllare sul sito della compagnia',
  },
};

const add_bag_details = (key, details, total) => {
  if (!details || !key || !details.quantity) {
    return total[key];
  }
  const item = INFERABLE_AMENITIES[key];
  item.formatted = item.description(details.quantity);
  if (details.weight && details.weightUnit) {
    item.formatted = `${item.formatted} ${details.weight}${details.weightUnit}`;
    delete item.tooltip;
  }
  return item;
};

export const infer_included_bags_as_amenities = (flight_offer) => {
  const { travelerPricings = [] } = flight_offer || {};
  const inferred = travelerPricings
    .flatMap((pricing) => pricing.fareDetailsBySegment || [])
    .reduce((total, included) => {
      const { includedCabinBags, includedCheckedBags, includedHandBags } =
        included;

      return {
        'INF:BACKPACK': add_bag_details(
          'INF:BACKPACK',
          includedHandBags,
          total
        ),
        'INF:CABIN': add_bag_details('INF:CABIN', includedCabinBags, total),
        'INF:CHECKED': add_bag_details(
          'INF:CHECKED',
          includedCheckedBags,
          total
        ),
      };
    }, {});

  const amenities = Object.values(inferred)
    .filter((amenity) => !!amenity)
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .map((amenity) => ({
      ...amenity,
      description: amenity.formatted,
      amenityType: 'BAGGAGE',
      isChargeable: false,
      isSynthetic: true,
    }));
  return amenities;
};
